<template>
  <article class="advanteges_Container">
    <h3 class="wow fadeInUp">{{ title }}</h3>
    <section class="specification_container">
      <div class="wow fadeInUp" v-for="(item, index) in data" :key="index">
        <i :class="item.icon" />
        <p>{{ item.name }}</p>
        <p>{{ item.description }}</p>
      </div>
    </section>
  </article>
</template>

<script>
export default {
  name: "ProjectPageAdvantages",
  props: ["title", "data"],
};
</script>

<style></style>
